import React, { FunctionComponent, memo, useEffect } from 'react';
import { connect } from 'react-redux';

import { TranslatedString } from '@bigcommerce/checkout/locale';

export interface LoadingNotificationProps {
    isLoading: boolean;
    loadingStage: string;
    resetLoadingStage: () => void;
}

const LoadingNotification: FunctionComponent<LoadingNotificationProps> = ({
    isLoading,
    loadingStage,
    resetLoadingStage
}) => {
    useEffect(() => { if (!isLoading) resetLoadingStage() }, [isLoading])

    if (!isLoading) {
        return null;
    }

    return (
        <div className="loadingNotification">
            <div className="loadingNotification-label optimizedCheckout-loadingToaster">
                <div className="spinner" />

                <span aria-live="assertive" className="label" role="alert">
                    <TranslatedString id="common.loading_text" />{' '}
                    { loadingStage.length > 0 && <TranslatedString id={loadingStage} /> }
                </span>
            </div>
        </div>
    );
};

const mapStateToProps = (state: { global: { loadingStage: string } }) => {
    const {
        global: { loadingStage },
    } = state;

    return {
        loadingStage,
    };
};

export default memo(connect(mapStateToProps)(LoadingNotification));
